import { render, staticRenderFns } from "./AllCrossOrderList.vue?vue&type=template&id=2a8ed4b6&scoped=true"
import script from "./AllCrossOrderList.vue?vue&type=script&lang=js"
export * from "./AllCrossOrderList.vue?vue&type=script&lang=js"
import style0 from "./AllCrossOrderList.vue?vue&type=style&index=0&id=2a8ed4b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ed4b6",
  null
  
)

export default component.exports